import Pause from "./SVG/pause.svg?react";

const PauseIcon = () => {
  return <Pause />;
};

export default PauseIcon;
